<template>
  <div class="sub-question"
       :style="{ marginLeft: `${depth * 1.5}rem` }">
    <div v-if="subQuestion.text"
         class="sq-text"
         v-html="subQuestion.text"></div>
    <div class="sq-options">
      <div v-for="option in subQuestion.answer_options"
           :key="`subQuestion_${subQuestion.id}_option_${option.id}`"
           class="sq-option"
           :class="{
             'sq-selected': isOptionSelected(option.id),
             'not-editable': !isEditable,
             'is-loading': isSaving,
           }"
           @click="optionClicked(option.id)">
        <b-icon pack="far"
                :icon="optionIcon(option.id)"/>
        <span class="user-select-none"
              v-html="option.txt"></span>
      </div>
    </div>
    <div v-if="isSelectionMissing"
         class="sq-validation has-text-danger has-text-weight-medium">
      Legalább {{ subQuestion.min_selected }} lehetőség kiválasztása kötelező.
    </div>
    <div v-if="subQuestion.text_after"
         class="sq-text-after"
         v-html="subQuestion.text_after"></div>
  </div>
</template>

<script>
export default {
  name: 'SubQuestion',
  props: {
    // nyers al-kérdés objektum (id, parent_id, trigger_on, text, text_after,
    // type: 'select' | 'checkbox', min_selected, answer_options, answer, ...)
    subQuestion: {
      type: Object,
      required: true,
    },
    depth: {
      type: Number,
      default: 0,
    },
    isSaving: {
      type: Boolean,
      default: false,
    },
    // null → az ellenőrzés státusza dönt (csak kitöltés alatt szerkeszthető);
    // a bizottsági módosítás modal ezzel felülírja.
    editable: {
      type: Boolean,
      default: null,
    },
  },
  methods: {
    isOptionSelected (optionID) {
      if (this.subQuestion.type === 'checkbox') {
        return (this.subQuestion.answer || []).some(answerID => Number(answerID) === Number(optionID))
      }
      return this.subQuestion.answer !== null &&
        this.subQuestion.answer !== undefined &&
        Number(this.subQuestion.answer) === Number(optionID)
    },
    optionIcon (optionID) {
      if (this.subQuestion.type === 'checkbox') {
        return this.isOptionSelected(optionID) ? 'check-square' : 'square'
      }
      return this.isOptionSelected(optionID) ? 'check-circle' : 'circle'
    },
    optionClicked (optionID) {
      if (!this.isEditable || this.isSaving) {
        return
      }
      let newAnswer
      if (this.subQuestion.type === 'checkbox') {
        const currentAnswer = this.subQuestion.answer || []
        newAnswer = this.isOptionSelected(optionID)
          ? currentAnswer.filter(answerID => Number(answerID) !== Number(optionID))
          : [...currentAnswer, optionID]
      } else {
        if (this.isOptionSelected(optionID)) {
          return
        }
        newAnswer = optionID
      }
      // A mentést a szülő végzi (Question, ill. a bizottsági modal): csak ő látja az
      // összes al-kérdést, márpedig a sub_question_answer és a
      // sub_question_answer_items csak együtt küldhető.
      this.$emit('change', newAnswer)
    },
  },
  computed: {
    isEditable () {
      if (this.editable !== null) {
        return this.editable
      }
      return Number(this.$store.state.inspection.selected.status_id) === 3
    },
    isSelectionMissing () {
      return this.isEditable &&
        this.subQuestion.type === 'checkbox' &&
        (this.subQuestion.answer || []).length < (this.subQuestion.min_selected || 0)
    },
  },
}
</script>

<style lang="scss"
       scoped>
@import "../../assets/css/_custom-variables.scss";

.sub-question {
  padding: .5rem 0;

  .sq-text, .sq-text-after {
    white-space: pre-line;
    font-weight: 500;
  }

  .sq-options {
    padding: .25rem 0;

    .sq-option {
      display: flex;
      align-items: flex-start;
      padding: .25rem .5rem;
      margin: .15rem 0;
      border: 1px solid $primary;
      cursor: pointer;

      .icon {
        margin-right: .5rem;
        flex-shrink: 0;
      }

      &:hover {
        opacity: .9;
      }

      &.not-editable {
        border: none !important;
        background: none !important;
        color: $dark-grey !important;
        cursor: default;
      }

      &.is-loading {
        opacity: .8;
        cursor: not-allowed;
      }

      &.sq-selected {
        background: $primary;
        color: $white;
      }
    }
  }
}
</style>
